module.exports = __webpack_public_path__ + "static/img/cmmi3.a428717e.png";